import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { InvocaService } from 'src/app/base/services/invoca.service';
import { Postulante } from '../interfaces/postulante';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class PostulantesService {

  constructor(
    private invoke: InvocaService,
    private sessionService: SessionService
  ) {}

  async comprobarRunExistente(run: number) {
    return this.invoke.httpInvoke('public/comprobarRunExistente', {
      run: run
    });
  }

  async comprobarPasaporteExistente(nroPasaporte: string) {
    return this.invoke.httpInvoke('public/consultaRutPasaporte', {
      nroPasaporte: nroPasaporte
    });
  }

  async comprobarCorreoExistente(correo: string) {
    return this.invoke.httpInvoke('public/comprobarCorreoExistente', {
      correo: correo
    });
  }

  async getCantidadPostulantes() {
    return this.invoke.httpInvoke('public/getCantidadPostulantes');
  }

  async actualizarDatosContacto(postulante: Postulante) {
    return this.invoke.httpInvoke('postulantes/actualizarDatosContacto', {
      direccion: postulante.direccion,
      id_region: postulante.id_region,
      id_comuna: postulante.id_comuna,
      telefono: postulante.telefono,
      ocupacion: postulante.ocupacion,
      empresa: postulante.empresa
    });
  }

  async consultarDatos() {
    return this.invoke.httpInvoke('postulantes/consultarDatos');
  }

}
